/**
 * Azure naming rules and small environment helpers shared by the Apprise VM wizard (mirrors the backend rules in
 * apprise_vm/validation_common.py).
 */

export const RESOURCE_GROUP_RE = /^[-\w._()]{1,90}$/
export const AZURE_NAME_RE = /^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,78}[a-zA-Z0-9_]$/
export const VM_SIZE_RE = /^Standard_[A-Za-z0-9_]+$/
export const LOG_ANALYTICS_ID_RE =
  /^\/subscriptions\/[^/]+\/resourceGroups\/[^/]+\/providers\/Microsoft\.OperationalInsights\/workspaces\/[^/]+$/i

export function isValidResourceGroupName(name: string): boolean {
  return RESOURCE_GROUP_RE.test(name) && !name.endsWith('.')
}

/** Portal environments that are production-grade (backup is on by default, purge protection applies). */
export const PRODUCTION_ENVS: ReadonlySet<string> = new Set(['production', 'prod_usgov'])

/** "East US 2" → "eastus2" (Azure location code). Already-coded values pass through. */
export function regionToLocation(region: string): string {
  return region.toLowerCase().replace(/[^a-z0-9]/g, '')
}
